<template>
  <textarea v-model="text" class="uk-textarea"></textarea>
</template>

<script>
export default {
  name: 'b-textarea',
  props: {
    value: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      text: this.value
    }
  },
  watch: {
    value(value) {
      this.text = value
    },
    text(val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style scoped></style>
